import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapPopupSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcappopup: {
      group: 'inline',
      inline: true,
      clampCondition: true,
      content: 'inline*',
      defining: true,
      parseDOM: [{
        tag: 'MadCap\\:popup'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:popup',
      // specContent: 'madcappopuphead madcappopupbody',
    },

    madcappopuphead: {
      group: 'inline',
      inline: true,
      content: 'inline*',
      defining: true,
      parseDOM: [{
        tag: 'MadCap\\:popupHead',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:popupHead',
      // specContext: 'madcappopup'
    },

    madcappopupbody: {
      group: 'inline',
      inline: true,
      code: true,
      content: 'inline*',
      defining: true,
      isolating: true,
      parseDOM: [{
        tag: 'MadCap\\:popupBody',
        preserveWhitespace: 'full'
      }],
      toDOM(node) {
        const outputSpec = nodeToDOM(node);
        // Enable popover behavior and make non-editable by default. This works in conjunction with the node view.
        outputSpec.dom.setAttribute('popover', 'auto');
        outputSpec.dom.setAttribute('contenteditable', 'false');
        return outputSpec;
      },
      tagName: 'MadCap:popupBody',
      // specContext: 'madcappopup'
    }
  } satisfies Record<string, NodeSpec>;
}
